
const showFooter = 'showfooter'
const hideFooter = 'hidefooter'
const showNavbar = 'shownavbar'
const hideNavbar = 'hidenavbar'
const getGoodslistMutation = 'getgoodslist'
export { showFooter, hideFooter, showNavbar, hideNavbar, getGoodslistMutation }
